/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { RestRequest, RestContext } from 'msw';
import OpenAPIBackend from 'openapi-backend';
import definition from '@gslc/models/open-api-autogenerated.yml';

const api = new OpenAPIBackend({ definition });
api.register('notFound', (c, res, ctx) => res(ctx.status(404)));
api.register('notImplemented', async (c, res, ctx) => {
  const { status, mock } = await api.mockResponseForOperation(
    c.operation.operationId ? c.operation.operationId : ''
  );
  return res(ctx.status(status), ctx.json(mock));
});

export const handleRequest = (
  req: RestRequest,
  res: unknown,
  ctx: RestContext
) => {
  const request = {
    method: req.method,
    path: req.url.pathname + req.url.search,
    body: req.body,
    headers: req.headers.raw(),
  };
  return api.handleRequest(request, res, ctx);
};
